import { FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

export const YourShoppingBagIsEmpty = (
  <FormattedMessage {...commonMessages.yourShoppingBagIsEmpty} />
);

export const FreeShippingAndReturns = (
  <FormattedMessage {...commonMessages.freeShippingAndReturns} />
);
